import { render } from "./BodyTrade.vue?vue&type=template&id=671cf56f"
import script from "./BodyTrade.vue?vue&type=script&lang=js"
export * from "./BodyTrade.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pages/reports/windowOverlay/reportInfo/BodyTrade.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "671cf56f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('671cf56f', __exports__)) {
    api.reload('671cf56f', __exports__)
  }
  
  module.hot.accept("./BodyTrade.vue?vue&type=template&id=671cf56f", () => {
    api.rerender('671cf56f', render)
  })

}


export default __exports__